import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { withRouter, BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import Reducer from "./reducer";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as langsBase from "./translations";

const initialState = {
	language: "poland",
	langBase: langsBase.poland,
	showModal: false,
	fetching: false,
	ekipa: null,
	services: null,
	stepBtn: true,
	czasPracy: null,
	message: false,
	messageText: {
		text: null,
		typeMessage: null
	},
	date: null,
	activeMenu: null
};

const store = createStore(
	Reducer,
	initialState,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const App1 = withRouter(App);

ReactDOM.render(
	<Provider store={store}>
		<Router>
			<Route path="/" component={App1} />
		</Router>
	</Provider>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
